import { Link } from "react-router-dom";
import {
  Button,
  Header,
  HeaderContainer,
  HeaderName,
  HeaderGlobalBar,
  HeaderGlobalAction,
} from "@carbon/react";

export const View = ({ handleComplete, handleCancel }) => {
  return (
    <HeaderContainer
      render={({ isSideNavExpanded, onClickSideNavExpand }) => (
        <Header
          className="header-transparency-cover onboarding-header"
          aria-label="Save and continue"
        >
          <span className="font-ctm--bold">Activate Your Account</span>

          <HeaderGlobalBar>
            <Button
              className="switchapp-themed mr-5"
              kind="tertiary"
              size="sm"
              onClick={handleCancel}
            >
              Save for later
            </Button>

            <Button
              className="switchapp-themed onboarding-header--button"
              size="sm"
              onClick={handleComplete}
            >
              Activate profile
            </Button>
          </HeaderGlobalBar>
        </Header>
      )}
    />
  );
};
